import React, { useState } from "react";
import styles from "../Casefile.module.scss";
import CloseButton from "./CloseButton";

import { Link } from "@reach/router";

function Tulip(props) {
  return (
    <div className={styles.queryBox}>
      <CloseButton setSelected={props.setSelected} />
      <div className={styles.questions}>
        <p>Hi I'm a Tulip, could you help me?</p>
        <p>I’m stuck here in this giant planter on Bold Street.</p>
        <p>Humans perpetuate this virus because they think I look pretty.</p>
        <p>
          #tulipvirus #prettytulip I would like humans to make me better and
          cure me of my virus, but they won't. #nocure #selfishhumans Humans are
          selfish.
        </p>
        <p>#selfishhuman I wish I was a snowdrop</p>
        <p>
          Could you please speak up for me and write an Incident report asking
          the humans to help me with my problem?
        </p>
      </div>
    </div>
  );
}

export default Tulip;
